import React from 'react';

function TermsOfService() {
  return (
    <>
      <section className="py-20 relative overflow-hidden" id="terms-of-service">
        <div className="absolute bottom-0 right-0 -z-10 w-96 h-96 bg-up247-50 rounded-full filter blur-3xl opacity-30"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <h1 className="text-up247-800 font-bold">Terms of Service</h1>
          <div className="terms-content">
            <p className="pl-4">
              Welcome to up247. By accessing our services, you agree to these terms and conditions.
            </p>
            <br/>
            <h2 className="text-up247-800 font-bold">1. Service Usage</h2>
            <p className="pl-4">
              Our platform provides trading account management tools. You must use these services responsibly 
              and in accordance with all applicable laws and regulations.
            </p>
            <br/>
            <h2 className="text-up247-800 font-bold">2. User Obligations</h2>
            <p className="pl-4">
              As a user, you agree to:
              <ul className="list-disc pl-8 space-y-2">
                <li>Provide accurate information</li>
                <li>Maintain the security of your account</li>
                <li>Comply with all trading regulations</li>
                <li>Not misuse our services</li>
              </ul>
            </p>
            <br/>
            <h2 className="text-up247-700 font-bold">3. Limitation of Liability</h2>
            <p className="pl-4">
              up247 is not liable for any financial losses incurred through the use of our services.
              Trading involves risk, and all decisions are ultimately your responsibility.
            </p>
            <br/>
            <p>
              For questions about these terms, please contact us at support@up247.org.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsOfService;
